import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { selectors as apiSelectors, actions as apiActions } from 'zender-api-client';

import Streams from './Streams.component';

const StreamsContainer = props => <Streams {...props} />;

const mapStateToProps = state => ({
	availableStreams: apiSelectors.channel.streamsSelector(state),
	status: apiSelectors.channel.statusSelector(state),
});

const mapDispatchToProps = dispatch => ({
	clearAndGetChannel: bindActionCreators(
		apiActions.channel.uiActions.clearAndGetChannel,
		dispatch
	),
});

StreamsContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(StreamsContainer)
);



// WEBPACK FOOTER //
// ./src/ui/streams/Streams.container.js